import type { LocationQhinConfigurationFields, QhinAddress } from 'services/api/fields/admin/location';
import http from 'services/http';

const URL = 'admin/location_qhin_configurations';

export type LocationQhinConfigurationParams = {
  locationId: string;
  legalName?: string;
  doingBusinessAsName?: string;
  corporateAddress?: QhinAddress;
  siteOfCareAddress?: QhinAddress;
  npi?: string;
  websiteName?: string;
  websiteUrl?: string;
  qhinType?: string;
  oid?: string;
  evidenceHealthCareProvider?: string;
  evidenceCoveredEntity?: string;
  lookbackDays?: number;
  pollingDays?: number;
  pollingIntervalHours?: number;
  readyToSubmit?: boolean;
};

export async function adminCreateLocationQhinConfiguration(
  params: LocationQhinConfigurationParams
): Promise<LocationQhinConfigurationFields> {
  return http.post<LocationQhinConfigurationFields>(URL, params).then((res) => res.data);
}

export async function adminUpdateLocationQhinConfiguration(
  id: string,
  params: Partial<LocationQhinConfigurationParams>
): Promise<LocationQhinConfigurationFields> {
  return http.patch<LocationQhinConfigurationFields>(`${URL}/${id}`, params).then((res) => res.data);
}
